import { render } from "./DoubleThumbnail.vue?vue&type=template&id=48e37d85&ts=true"
import script from "./DoubleThumbnail.vue?vue&type=script&lang=ts"
export * from "./DoubleThumbnail.vue?vue&type=script&lang=ts"

import "./DoubleThumbnail.vue?vue&type=style&index=0&id=48e37d85&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__